import type { ChangelogEntry } from "../types";

/** VIB-3050 PR 2: Leads-tavlen, bookerens egen pipe. */
export const LEADS_TAVLE_2026_11: ChangelogEntry = {
  id: "2026-11-03-leads-tavle",
  date: "2026-11-03",
  title: "Leads har fått en tavle med din egen pipe",
  summary:
    "Ved siden av «Ett om gangen» viser «Tavle» leadene dine i fire søyler: å kontakte, skal sende mail, skal ringe opp igjen og møte booket. Å dra et kort gjør det samme som tasten på leadkortet.",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Fire søyler",
          kind: "nytt",
          body: "«Leads å kontakte» viser de neste leadene køen din gir deg, med telefonnummer. «Skal sende mail» og «Skal ringe opp igjen» er sortert på dato, og det som har passert, er merket forfalt. «Møte booket» viser møtene du har booket de siste 14 dagene.",
        },
        {
          title: "Dra for å logge utfall",
          kind: "nytt",
          body: "Dra et kort til en søyle, så åpnes samme dialog som tasten: dato for mailen, tidspunkt for ny samtale eller bookingen. Nederst kan du slippe kortet på «Ikke svar», «Avvist», «Feil nummer» eller «Tilbake til poolen». Avbryter du, blir kortet liggende.",
        },
        {
          title: "Skal sende mail",
          kind: "nytt",
          body: "Nytt utfall: velg dato og eventuelt hva som skal sendes. Leadet er ditt og ligger på tavlen til du har sendt mailen og drar det videre.",
        },
        {
          title: "Uten mus",
          kind: "nytt",
          body: "Velg et kort og trykk 1–6, eller bruk «Flytt til» på kortet.",
        },
      ],
    },
  ],
};
